import { To, useLocation } from 'react-router-dom'

export const usePath = (path: string): To => {
  const location = useLocation()
  return { pathname: path, search: location.search }
}
